export type ProjectEditNameSelectOption = {
  value: string;
  label: string;
};

/**
 * 名称多选：输入框有搜索词时，候选列表不展示已勾选项，避免与下方已选标签重复。
 * 无搜索词时保留完整候选（含已选），便于继续浏览与取消勾选。
 */
export function filterProjectEditNameOptionsForSearch(
  options: ProjectEditNameSelectOption[],
  selectedValues: string[],
  searchKeyword: string,
): ProjectEditNameSelectOption[] {
  if (!searchKeyword.trim()) {
    return options;
  }
  if (selectedValues.length === 0) {
    return options;
  }
  const selected = new Set(selectedValues);
  return options.filter((option) => !selected.has(option.value));
}
